import {
  ChartDeviceTypes,
  ChartOrderNumber,
} from 'components/segments/CustomerAttributes';
import { CardBackground } from 'components/ui';
import ChartOrderSources from './ChartOrderSources';

export default function CustomerAttributes() {
  return (
    <section className="mt-7 md:mt-16">
      <p className="text-base tracking-wide md:text-2xl ">
        Customer attributes
      </p>
      <div className="mt-2 -mx-segments-10px md:mx-0 md:mt-6">
        <CardBackground>
          <div className="p-10">
            <ChartOrderNumber />
            <ChartDeviceTypes />
            <ChartOrderSources />
          </div>
        </CardBackground>
      </div>
    </section>
  );
}
